type ShareGraphProps = {
  standard: string;
};
export function ShareGraph({ standard }: ShareGraphProps) {
  return (
    <euroland-tool
      data-tool-name="ShareGraph"
      data-tool-company="3416"
      data-tool-language={standard}
    />
  );
}
